import React, { createContext, useCallback, useContext, useState } from 'react';

const ToastContext = createContext();

export const useToast = () => {
	const ctx = useContext(ToastContext);
	if (!ctx) throw new Error('useToast must be used within ToastProvider');
	return ctx;
};

export const ToastProvider = ({ children, timeout = 4000 }) => {
	const [toasts, setToasts] = useState([]);

	const remove = useCallback((id) => setToasts(t => t.filter(toast => toast.id !== id)), []);

	const push = useCallback((message, type = 'info') => {
		const id = crypto.randomUUID();
		const toast = { id, message, type, createdAt: Date.now() };
		setToasts(t => [...t, toast]);
		setTimeout(() => remove(id), timeout);
		return id;
	}, [remove, timeout]);

	// Convenience methods for different toast types
	const success = useCallback((message) => push(message, 'success'), [push]);
	const error = useCallback((message) => push(message, 'error'), [push]);
	const warning = useCallback((message) => push(message, 'warning'), [push]);
	const info = useCallback((message) => push(message, 'info'), [push]);

	return (
		<ToastContext.Provider value={{ toasts, push, remove, success, error, warning, info }}>
			{children}
		</ToastContext.Provider>
	);
};

export default ToastContext;
